import styled, { css } from 'styled-components';

export const StyledCreditCard = styled.img`
  position: absolute;
  top: 30%;
  left: 5%;
  max-width: 410px;
  width: 100%;
`;